import React from "react";
import Main from "../tab-home/Main";
import AddTabModal from "../modals/AddTabModal";

function Home(props) {
	return (
		<>
			{/*ADD TAB MODAL */}
			<AddTabModal
				openModal={props.openModal}
				closeModal={props.closeModal}
				modalIsOpen={props.modalIsOpen}
				fetchFirebase={props.fetchFirebase}
				// userID={props.userID}
				user={props.user}
			/>

			{/* MAIN TABS COMPONENT */}
			<Main
				tabs={props.tabs}
				fetchFirebase={props.fetchFirebase}
				userID={props.userID}
				user={props.user}
				userName={props.userName}
			/>

			{/* OPEN MODAL TAB BUTTON*/}
			<button
				className="modal-button modal-button-tab"
				onClick={props.openModal}
			>
				<i class="fas fa-plus"></i>
			</button>
		</>
	);
}

export default Home;
